import { render, staticRenderFns } from "./addParams.vue?vue&type=template&id=74be3253&"
import script from "./addParams.vue?vue&type=script&lang=js&"
export * from "./addParams.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports